<template>
  <div class="news-info-wrapper">
    <div class="news-info">
      <div class="img-info" @click="handleClickInfo(activeInfo)">
        <img :src="activeInfo.image" alt="" />
        <div class="desc">
          <div class="title">{{ activeInfo.title }}</div>
          <div class="sub-title">{{ activeInfo.summary }}</div>
          <div class="time">{{ activeInfo.createTime }}</div>
        </div>
      </div>
      <ul class="news-list">
        <li
          v-for="item in bannerList"
          :key="item.id"
          @click="handleMouseEnter(item)"
        >
          <div class="news-tit" :class="{ active: item.id === activeKey }">
            {{ item.title }}
          </div>
          <div class="news-desc">{{ item.summary }}</div>
          <div class="time">{{ item.createTime }}</div>
        </li>
      </ul>
    </div>
    <div class="timeline">
      <div class="tabs">
        <template v-for="tab in tabList">
          <em
            :key="tab.id"
            :class="{ active: tab.id === tabKey }"
            @click="handleClickTab(tab.id)"
          >
            {{ tab.name }}
          </em>
        </template>
      </div>
      <div class="info-box clearfix">
        <div v-if="tabKey === 0" class="consult fl w1130">
          <div v-for="item in newsList" :key="item.id" class="con-wrap">
            <div class="content" @click="handleClickNewDetail(item, 1)">
              <h3>{{ item.title }}</h3>
              <p>{{ item.summary }}</p>
              <span>{{ item.createTime }}</span>
            </div>
            <img :src="item.image" class="consult-img" />
          </div>
        </div>
        <ul v-if="tabKey === 1" class="notice fl w1130">
          <li
            v-for="item in newsList"
            :key="item.id"
            @click="handleClickNewDetail(item, 2)"
          >
            <em>《{{ item.title }}》 {{ item.summary }}</em>
            <span>{{ item.createTime }}</span>
          </li>
        </ul>
        <div v-if="tabKey === 2" class="activity fl w1130">
          <div
            v-for="item in activeList"
            :key="item.id"
            class="box"
            @click="handleToActiveDetail(item)"
          >
            <div class="img-wrap">
              <img :src="item.image" alt="" />
              <span v-if="item.isEnd" class="tips">已结束</span>
              <div class="img-info">
                <span>已报名：{{ item.signUpNum }} 人</span>
                <span>浏览：{{ item.clickNum }}</span>
              </div>
            </div>
            <div class="desc">
              <p class="text">{{ item.activityName }}</p>
              <p class="time">报名 {{ item.startDate }} 至 {{ item.stopDate }}</p>
              <div class="bottom-info">
                <span class="address">地址：{{ item.address }}</span>
                <span class="more">了解更多</span>
              </div>
            </div>
          </div>
        </div>
        <div class="time-line fr">
          <div>时间</div>
          <strong><img src="~@/assets/img/search-arrow.svg" /></strong>
          <span>2022</span>
          <span>2021</span>
          <span>2020</span>
          <span>2019</span>
          <strong><img src="~@/assets/img/search-arrow.svg" /></strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { artNewsList, artActivityList } from "@/api/NewInfo";

function formatList(list = []) {
  return list.map((item) => ({
    ...item,
    createTime: item.createTime ? item.createTime.split(" ")[0] : "",
  }));
}

export default {
  name: "NewsInfo",
  data() {
    return {
      activeKey: 0,
      activeInfo: {},
      tabKey: 0,
      tabList: [
        { id: 0, name: "新闻资讯" },
        { id: 1, name: "公告" },
        { id: 2, name: "活动" },
      ],
      params: {
        classify: 1,
        keyword: "",
        limit: 10,
        page: 0,
      },
      newsList: [],
      bannerList: [],
      activeList: [],
      activeParams: {
        limit: 10,
        page: 1,
      },
    };
  },
  mounted() {
    this.artNewsListFunc(true);
  },
  methods: {
    handleToActiveDetail(item) {
      this.$router.push({
        path: "ActiveDetail",
        query: {
          id: item.id,
        },
      });
    },
    handleClickNewDetail(item, currentActiveKey) {
      this.$router.push({
        path: "NewsDetail",
        query: {
          id: item.id,
          currentActiveKey,
        },
      });
    },
    handleClickInfo(item) {
      if (!item || !item.id) {
        return;
      }
      this.$router.push({
        path: "NewsDetail",
        query: {
          id: item.id,
          currentActiveKey: this.tabKey === 1 ? 2 : 1,
        },
      });
    },
    artNewsListFunc(resetBanner = false) {
      artNewsList(this.params)
        .then((res) => {
          const data = formatList(res.data || []);
          this.newsList = data;
          if (resetBanner || this.tabKey !== 1) {
            this.bannerList = data.slice(0, 4);
            this.activeInfo = this.bannerList[0] || {};
            this.activeKey = this.activeInfo.id || 0;
          }
        })
        .catch(() => {
          this.newsList = [];
          this.bannerList = [];
          this.activeInfo = {};
          this.activeKey = 0;
        });
    },
    handleMouseEnter(item) {
      this.activeKey = item.id;
      this.activeInfo = item;
    },
    handleClickTab(key) {
      if (this.tabKey === key) {
        return;
      }
      this.tabKey = key;
      if (+key === 0) {
        this.params.classify = 1;
        this.artNewsListFunc(true);
      } else if (+key === 1) {
        this.params.classify = 2;
        this.artNewsListFunc(true);
      } else {
        this.artActivityListFunc();
      }
    },
    artActivityListFunc() {
      artActivityList(this.activeParams)
        .then((res) => {
          this.activeList = (res.data && res.data.content) || [];
        })
        .catch(() => {
          this.activeList = [];
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.news-info-wrapper {
  border-top: 1px solid #f2f2f2;
  .news-info {
    display: flex;
    .img-info {
      width: calc(100% - 527px);
      height: 606px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .desc {
        padding-left: 15px;
        width: 100%;
        height: 130px;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: rgba(51, 51, 51, 0.38);
        color: #fff;
        .title {
          padding-top: 28px;
          line-height: 20px;
          font-size: 20px;
        }
        .sub-title {
          padding: 22px 0 23px;
          line-height: 15px;
          font-size: 15px;
        }
        .time {
          padding-right: 41px;
          line-height: 13px;
          font-size: 13px;
          text-align: right;
        }
      }
    }
    .news-list {
      box-sizing: border-box;
      width: 527px;
      padding: 0 48px 0 28px;
      margin: 0;
      li {
        padding-left: 10px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        .news-tit {
          height: 2.55vw;
          line-height: 2.55vw;
          font-size: 15px;
          color: #333;
          white-space: nowrap;
          position: relative;
          user-select: none;
          &.active {
            color: #ea514e;
            &::before {
              background: #ea514e;
            }
          }
          &::before {
            content: "";
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #333;
            position: absolute;
            left: -10px;
            top: 20px;
          }
        }
        .news-desc {
          min-height: 60px;
          line-height: 20px;
          font-size: 13px;
          color: #7f7f7f;
        }
        .time {
          padding: 13px 12px 11px 0;
          font-size: 13px;
          color: #aaa;
          text-align: right;
        }
      }
    }
  }
  .timeline {
    margin: 0 auto 120px;
    width: 1240px;
    .tabs {
      padding: 50px 0 22px;
      & span:nth-last-child(1) {
        display: none;
      }
      em {
        line-height: 20px;
        font-size: 20px;
        color: #7f7f7f;
        cursor: pointer;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          vertical-align: top;
          width: 2px;
          height: 20px;
          margin: 0 27px;
          background-color: #2d3f51;
        }

        &:nth-last-child(1)::after {
          display: none;
        }
      }
      .active {
        color: #2d3f51;
      }
    }
    .info-box {
      .consult {
        width: 1130px;
        margin-bottom: 50px;
        .con-wrap {
          display: flex;
          border-bottom: 1px solid #f0f0f0;
        }
        .content {
          width: 918px;
          h3 {
            margin: 0;
            padding: 28px 0 18px;
            font-size: 15px;
            color: #333;
          }
          p {
            margin-bottom: 34px;
            line-height: 19px;
            color: #7f7f7f;
          }
          span {
            display: block;
            font-size: 13px;
            color: #aaa;
            margin-bottom: 12px;
          }
        }
        .consult-img {
          margin-top: 30px;
          width: 198px;
          height: 112px;
        }
      }
      .notice {
        li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 49px;
          em {
            font-size: 15px;
            color: #333;
            width: 924px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            font-size: 13px;
            color: #aaa;
          }
        }
      }
      .activity {
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .box {
          margin-bottom: 16px;
          width: 562px;
          box-shadow: 0px 0px 8px rgb(0 0 0 / 9%);
          &:hover .desc {
            background: #2d3f51;
            .text,
            .time,
            .address,
            .more {
              color: #fff !important;
            }
          }
          .img-wrap {
            position: relative;
            width: 562px;
            height: 321px;
            img {
              width: 562px;
              height: 321px;
            }
            .tips {
              position: absolute;
              left: 0;
              top: 18px;
              width: 70px;
              height: 22px;
              line-height: 22px;
              font-size: 13px;
              color: #fff;
              background-color: #2d3f51;
              text-align: center;
            }
            .img-info {
              padding: 0 18px 0 16px;
              height: 34px;
              line-height: 34px;
              font-size: 13px;
              color: #fff;
              background-color: rgba(0, 0, 0, 0.4);
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              display: flex;
              justify-content: space-between;
            }
          }
          .desc {
            padding: 13px 16px 14px;
            p {
              margin: 0;
            }
            .text {
              line-height: 21px;
              font-size: 15px;
              color: #333;
            }
            .time {
              font-size: 13px;
              line-height: 21px;
              color: #7f7f7f;
            }
            .bottom-info {
              padding-top: 20px;
              .address {
                font-size: 13px;
                line-height: 15px;
                color: #7f7f7f;
              }
              .more {
                float: right;
                font-size: 13px;
                color: #333;
              }
            }
          }
        }
      }
      .time-line {
        width: 48px;
        text-align: right;
        div {
          padding-right: 10px;
          height: 27px;
          line-height: 27px;
          border-right: 4px solid #2d3f51;
          font-weight: 700;
          font-size: 15px;
          color: #2d3f51;
        }
        strong {
          display: block;
          height: 34px;
          cursor: pointer;
          position: relative;
        }
        img {
          width: 10px;
          height: 4px;
          position: absolute;
          right: 10px;
        }
        strong:nth-of-type(1) img {
          transform: rotate(180deg);
          top: 12px;
        }
        strong:nth-of-type(2) img {
          top: 18px;
        }
        span {
          display: block;
          height: 39px;
          line-height: 39px;
          font-size: 14px;
          color: #333;
        }
      }
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .w1130 {
      width: 1130px;
    }
  }
}
</style>
